import api from '../../axios_api'
import _ from 'lodash'
import Promise from 'bluebird'
import router from '../../main'


const buildFormData = function (payload) {
    let formData = new FormData();  /*
        Add the form data we need to submit
    */
    for (var i = 0; i < payload.files.length; i++) {
        let file = payload.files[i];

        if (!file) {
            file = new Blob(['test'], { type: "text/plain;charset=utf-8" });
        }

        formData.append(
            'files[' + i + ']',
            file,
            (file ? file.name : '')
        );
    }
    formData.append('encrypt', JSON.stringify({ encrypt: { data: payload.data } }));

    return formData;
}

const state = {
    workspaces: [],
    currentWorkspace: {},
    currentWorkspaceProfile: {},
    sellProRataData: [],
    buyProRataData: [],
    interestedDeals: []
}

const getters = {
    workspaces: (state) => state.workspaces,
    currentWorkspace: (state) => state.currentWorkspace,
    currentWorkspaceProfile: (state) => state.currentWorkspaceProfile,
    sellProRataData: (state) => state.sellProRataData,
    buyProRataData: (state) => state.buyProRataData,
    interestedDeals: (state) => state.interestedDeals
}
const mutations = {
    initialize(state) {
        state.workspaces = [];
        state.currentWorkspace = {};
        state.currentWorkspaceProfile = {};
        state.sellProRataData = [];
        state.buyProRataData = [];
        state.interestedDeals = [];
    },
    merge(state, payload) {
        // merge our local with what has returned
        if (_.isNil(payload) || _.isEmpty(payload)) return
        if (!_.isArray(payload)) payload = [payload]
        // state.workspacestage = payload;
        state.workspaces = _.map(state.workspaces, addr => {
            let index = _.findIndex(payload, function (a) { return a._id === addr._id })
            if (index >= 0) {
                return _.first(_.pullAt(payload, index))
            }
            return addr
        })
        if (!_.isEmpty(payload)) state.workspaces = _.concat(state.workspaces, payload)
        state.workspaces = _.without(state.workspaces, null, undefined)
    },
    remove(state, payload) {
        if (_.isNil(payload) || _.isEmpty(payload)) return
        // remove the item by the id (either _id or uaid)
        state.workspaces = _.filter(state.workspaces, function (a) { return a._id !== payload && a.uaid !== payload })
    },
    setDefaultPipeline(state, payload) {
        state.currentWorkspace = payload.payload;
    },
    setCurrentWorkspaceProfile(state, payload) {
        state.currentWorkspaceProfile = payload;
    },
    setSellProRataData(state, payload) {
        state.sellProRataData = payload;
    },
    setBuyProRataData(state, payload) {
        state.buyProRataData = payload;
    },
    setInterestedDeals(state, payload) {
        state.interestedDeals = payload;
    }
}

const actions = {
    start({ state, dispatch, commit }) {
        commit('initialize')
        dispatch('apiFetchworkspaces');
    },
    merge(state, payload) {
        // merge our local with what has returned
        if (_.isNil(payload) || _.isEmpty(payload)) return
        if (!_.isArray(payload)) payload = [payload]
        state.workspaces = payload
    },
    stop({ commit }) {
        // clean up
        commit('initialize')
    },
    apiFetchworkspaces({ commit, dispatch }) {
        if (localStorage.fiifi) {
            let fiifi = JSON.parse(localStorage.fiifi).user
            if (fiifi) {
                let url = `${fiifi.id}/fetch/workspace`;
                return api.get(url)
                    .then(res => {
                        commit('merge', res.data.encrypt.success)
                        return Promise.resolve(res.data.encrypt.success)
                    })
                    .catch(err => {
                        return Promise.reject(err)
                    })
            }
        }
    },
    apiPostworkspacesInst({ rootGetters, dispatch }, payload) {
        // payload should be a company instance
        let url = `${router.currentRoute.params.account_id}/create/workspace`;
        return api.post(url, { encrypt: { data: payload } })
            .then(res => {
                return Promise.resolve(res.data.encrypt)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiDefaultCreateWorkspace({ rootGetters, dispatch }, payload) {
        let url = `${router.currentRoute.params.account_id}/create/workspace`;
        return api.post(url, { encrypt: { data: payload } })
            .then(res => {
                // res should be the updated company info
                dispatch('apiFetchworkspaces')
                    .then(() => {
                    })
                    .catch(() => { })
                return Promise.resolve(res.data.encrypt.success)

            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiPatchworkspacesInst({ dispatch }, payload) {
        // payload should be a Company instance
        let url = `${router.currentRoute.params.account_id}/update/workspace`;

        return api.patch(url, { encrypt: { data: payload } })
            .then(res => {
                dispatch('apiFetchworkspaces')
                    .then(() => {
                    })
                    .catch(() => { })
                return Promise.resolve(res.data.encrypt)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiPatchworkspacesInst({ dispatch }, payload) {
        // payload should be a Company instance
        let url = `${router.currentRoute.params.account_id}/update/workspace`;

        return api.patch(url, { encrypt: { data: payload } })
            .then(res => {
                dispatch('apiFetchworkspaces')
                    .then(() => {
                    })
                    .catch(() => { })
                return Promise.resolve(res.data.encrypt)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiDeleteWorkspace({ dispatch, commit }, payload) {
        let url = `${payload.account_id}/${payload.workspace_id}/${payload.type}/delete/workspace`;
        return api.post(url, { encrypt: { data: payload } })
            .then(res => {
                commit('remove', payload._id)
                return Promise.resolve(res.data.encrypt)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiDefaultWorkspace({ dispatch, commit }, payload) {
        let url = `${payload.account_id}/${payload.workspace_id}/default/workspace`;
        return api.patch(url, { encrypt: { data: payload } })
            .then(res => {
                dispatch('apiFetchworkspaces')
                    .then(() => {
                    })
                    .catch(() => { })
                return Promise.resolve(res.data.encrypt)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiPostWorkspaceLogo({ commit }, payload) {
        if (_.isNil(payload) || _.isEmpty(payload)) return Promise.reject({ error: 'no arguments' })
        let formData = buildFormData(payload);
        let url = `/workspaceProfileUpload`;
        return api.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                return Promise.resolve(res)
            })
            .catch(err => {
                console.error(`Error during workspace Profile upload: ${err}`)
                return Promise.reject(err)
            })
    },
    apiFetchSellProRataData({ commit }, payload) {
        // payload should be a company instance
        let url = `dealRoom/${payload.account_id}`;
        return api.get(url)
            .then((res) => {
                commit('setSellProRataData', res.data.encrypt.success)
                return Promise.resolve(res.data.encrypt.success)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiFetchBuyProRataData({ commit }, payload) {
        // payload should be a company instance
        let url = `deals/${payload.account_id}`;
        return api.get(url)
            .then((res) => {
                commit('setBuyProRataData', res.data.encrypt.success)
                return Promise.resolve(res.data.encrypt.success)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiFetchInterestedDeals({ commit }, payload) {
        // payload should be a company instance
        let url = `interestedDeals/${payload.account_id}`;
        return api.get(url)
            .then((res) => {
                commit('setInterestedDeals', res.data.encrypt.success)
                return Promise.resolve(res.data.encrypt.success)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}